import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container} from 'react-bootstrap'
import FiltrosInforme from './filtros-informe'
//import FiltrosInforme from './informes'
import InformePrevios from './informes-previos'
import {Auth, LoadingComponent} from 'recupero-comunes'
import { obtenerInformesPrevios, configuracionFormAction, obtenerTiposInforme, obtenerCompanias, obtenerEstados, obtenerSituaciones, obtenerCriteriosFecha, obtenerCriteriosPendiente } from '../../store/actions/informes-administracion-action'

const InformeAdministracion = () => {
    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informeAdministracionReducer)
    const { cfg_formInf } = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    
    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, idform: 62})).toString('base64')
        dispatch(configuracionFormAction(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 282})).toString('base64')
            dispatch(obtenerTiposInforme(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, parametro: 1})).toString('base64')
            dispatch(obtenerCompanias(query))
         })    
         .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 289})).toString('base64')
            dispatch(obtenerSituaciones(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
            dispatch(obtenerInformesPrevios(query));
         })
        .then(()=>setLoading(false))
     }, [dispatch])
    return (
        <div>            
            <LoadingComponent show={loading}/>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                        {cfg_formInf && `${cfg_formInf.cfg_formInf['informes-title']}`}
                    </Card.Header>
                    <Card.Body>
                        <FiltrosInforme/>
                        <InformePrevios/>
                    </Card.Body>
                </Card>
            </Container>            
        </div>
  )
}
export default InformeAdministracion 